export const productCategories = [
  { key: 'G1', icon: 'bi-shield', color: 'bg-icon-blue' },
  { key: 'G4', icon: 'bi-cash-stack', color: 'bg-icon-orange' },
  { key: 'G2', icon: 'bi-graph-up', color: 'bg-icon-yellow' },
  { key: 'G3', icon: 'bi-building', color: 'bg-icon-purple' },
  { key: 'G5', icon: 'bi-people', color: 'bg-icon-pink' },
  { key: 'BONUS_OTHER', icon: 'bi-plus-lg', color: 'bg-icon-green' },
];
